export default __webpack_public_path__ + "static/media/whatsapp_logo.8bdec2c6.png";